import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

const BASE_URL = (process.env.REACT_APP_API_URL ?? '').replace(/\/$/, '');

export const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use(async (config) => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString() ?? '';
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch {
    // no session — request will 401
  }
  return config;
});
